enum OrderDetailsMapMarkerType {
  ONBOARDING = "ONBOARDING",
  OUTBOARDING = "OUTBOARDING",
  STANDARD = "STANDARD",
  WEATHERED = "WEATHERED",
}

export default OrderDetailsMapMarkerType;
